import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  px: ['2.5', '4'],
  pt: '0',
  pb: '2',
};
